import { render, staticRenderFns } from "./e-footer.vue?vue&type=template&id=6cc7a18b&scoped=true"
import script from "./e-footer.vue?vue&type=script&lang=js"
export * from "./e-footer.vue?vue&type=script&lang=js"
import style0 from "./e-footer.vue?vue&type=style&index=0&id=6cc7a18b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc7a18b",
  null
  
)

export default component.exports